import { getCurrentYear } from '../../common/utils/dateTime';

export const speakerConstants = {
    BACK_TO_SPEAKER_DIRECTORY: 'Back to Speaker Directory',
    MEMBER: 'MEMBER',
    VIEW_MY_YPO_PROFILE: 'View my YPO Profile',
    FEE_RANGE: 'Fee Range',
    WILLING_TO_NEGOTIATE_FEES: 'Willing to Negotiate Fees',
    TRAVELS_FROM: 'Travels from',
    SPOKEN_AT_YPO_EVENTS: 'Spoken at YPO Events',
    MY_CONTACT_INFORMATION: 'My Contact Information',
    TOPICS: 'Topics',
    LEADERSHIP_DEVELOPMENT: 'Leadership Development',
    PERSONAL_DEVELOPMENT: 'Personal Development',
    STRATEGY: 'Strategy',
    ABOUT_ME: 'About Me',
    SPEAKER_PARTICIPATES: 'Speaker Participates',
    PRESENTATIONS: 'Presentations',
    LANGUAGES_SPOKEN: 'Languages Spoken',
    REFERRALS: 'Referrals',
    TRAVEL_RESOURCE_PROGRAM: 'Travel Resource Program',
    SPEAKER_IS_AVAILABLE_TO_SPEAK_ONLINE_OR_VIRTUAL: 'Speaker is Available to Speak Online or Virtual',
    YES: 'Yes',
    NO: 'No',
    NON_MEMBER_SPEAKER_TYPE: 'Non-Member',
    CFF: 'CFF',
    CFF_FEE: '(Click here for CFF Fees)',
    CFF_INFORMATION_FEES: 'My CFF Information and Fees',
    CERTIFIED_FORUM_FACILITATOR: 'Certified Forum Facilitator Information',
    SINCE: 'Since',
    REGIONS: 'Primary Region: ',
    TAG_LINE: 'Tag line: ',
    CFF_RATING: 'Average CFF Rating (out of 5)',
    CFF_FEES_RATE: 'FEES (Daily Rate)',
    MINIMUM: 'Minimum',
    MAXIMUM: 'Maximum',
    QUALIFICATIONS: 'Qualifications: ',
    NUMBER_FORUM_PROGRAM: 'Number of forum programs',
    IN_PAST_YEAR: '(In the past year):',
    RETREAT_TOPIC: 'Retreat Topics: ',
    USD: 'USD',
    CFF_RATING_REQUIRED: 'CFF Rating Required',
    RULES: {
        CFFRating: [
            v => !!v || 'CFF Rating required',
            v => (!!v && v >= 0.0 && v <= 10.0) || 'Rating cannot be less than 0.00 and more than 10.00',
        ],
        CFFSince: [
            v => !!v || 'This field cannot be empty',
            v => (!!v && v >= 1980 && v <= getCurrentYear()) || 'Please enter a valid year',
        ],
        CFFMaxFeeRange: [],
    },
    ERROR_MESSAGES: {
        MinFees: 'Minimum fee cannot be more than or equal to maximum fee',
        MaxFees: 'Maximum fee cannot be less than or equal to minimum fee',
        Training_Name_Exists: 'Training Name already exists',
        Number_Of_Forum_Programs: 'Number of forum programs is mandatory',
    },
};

export const generateRange = (start, end, interval) => {
    let Range = [];
    Range = [];
    for (let i = start; i <= end; i += interval) {
        Range.push(i);
    }
    return Range;
};
export const feeRange = {
    steps: [0, 1000, 3000, 5000, 10000],
};
